var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.5,
    height: 22.772,
    viewBox: "0 0 58.5 22.772",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24875",
    "data-name": "Group 24875",
    transform: "translate(-417.53 -295.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37000",
    "data-name": "Path 37000",
    d: "M476.135,295.7c.1,1.312.778,2.54,2.585,3.866s3.28,2.2,4.5,2.952,4.439,2.547,5.11,3.02,3.02,1.738,3.112,3.294c.579-.839.976-1.709-.046-2.73a30.522,30.522,0,0,0-5.217-3.523c-1.769-1.007-6.192-3.523-7.23-4.255S476.28,296.443,476.135,295.7Z",
    transform: "translate(-15.996)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37001",
    "data-name": "Path 37001",
    d: "M491.621,309.965a37.954,37.954,0,0,0-5.323-3.989c-2.082-1.266-5.563-3.362-6.51-4.049s-2.439-1.762-2.563-2.452c.076,1.211.686,2.351,2.337,3.6s3.058,2.023,4.174,2.727,3.99,2.462,4.612,2.893a20.77,20.77,0,0,1,2.481,1.946A8.589,8.589,0,0,0,491.621,309.965Z",
    transform: "translate(-16.294 -1.031)",
    fill: "#03c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37002",
    "data-name": "Path 37002",
    d: "M490.5,312.057a41.439,41.439,0,0,0-4.125-2.9c-1.919-1.207-5.128-3.206-6-3.858s-2.243-1.673-2.349-2.317c.053,1.127.606,2.2,2.123,3.377s2.758,1.969,3.786,2.639,3.736,2.3,4.309,2.713c.465.334.886.654,1.24.936Z",
    transform: "translate(-16.513 -1.989)",
    fill: "#009"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37003",
    "data-name": "Path 37003",
    d: "M493.5,311.637a4.144,4.144,0,0,1-1.43,3.2,16.527,16.527,0,0,1-4.347,2.254c-.995.377-3.1,1.109-3.935,1.5a7.644,7.644,0,0,0-2.231,1.373,6.776,6.776,0,0,1,3.065-2.437c1-.5,2.918-1.327,4-1.83a18.38,18.38,0,0,0,3.776-2.071A2.849,2.849,0,0,0,493.5,311.637Z",
    transform: "translate(-17.478 -4.351)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37004",
    "data-name": "Path 37004",
    d: "M492.13,316.027c-.355,1.224-.606,1.876-2.46,2.849a42.179,42.179,0,0,1-5.857,2.071c-1.109.389-2.654.824-3.18,1.7a1.164,1.164,0,0,0-.035,1.224c-.526-.595-.583-.984-.5-1.339s.4-.881,1.442-1.487a27.788,27.788,0,0,1,4.335-1.853c1.556-.538,3.329-1.144,4.072-1.5S491.935,316.771,492.13,316.027Z",
    transform: "translate(-17.069 -5.549)",
    fill: "#03c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37005",
    "data-name": "Path 37005",
    d: "M491.806,318.812a6.947,6.947,0,0,1-3.123,2.036,27.278,27.278,0,0,1-2.86.663,11.62,11.62,0,0,0-2.917.8,4.579,4.579,0,0,0-1.384.892,8.3,8.3,0,0,1,3.066-.79,29.576,29.576,0,0,0,4.187-.606A3.952,3.952,0,0,0,491.806,318.812Z",
    transform: "translate(-17.467 -6.31)",
    fill: "#009"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37006",
    "data-name": "Path 37006",
    d: "M425.839,312.224l-4.632,10.755h-2.062l1.416-3.292-3.031-7.463h2.185l1.155,3.278.723,2.139.785-2.092,1.385-3.324Z",
    transform: "translate(0 -4.511)",
    fill: "#009"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37007",
    "data-name": "Path 37007",
    d: "M436.633,315.967a3.947,3.947,0,1,1-3.97-3.955A3.835,3.835,0,0,1,436.633,315.967Zm-6.016,0a2.068,2.068,0,1,0,4.124,0,2.142,2.142,0,0,0-2.062-2.247A2.084,2.084,0,0,0,430.616,315.967Z",
    transform: "translate(-3.06 -4.453)",
    fill: "#009"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37008",
    "data-name": "Path 37008",
    d: "M442.811,312.224v3.97a1.81,1.81,0,0,0,1.831,2.031,2,2,0,0,0,1.938-2.124v-3.877h1.862v7.6h-1.677l-.124-1.031a3.38,3.38,0,0,1-2.569,1.139c-1.815,0-3.139-1.369-3.139-3.723v-3.986Z",
    transform: "translate(-6.388 -4.511)",
    fill: "#009"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37009",
    "data-name": "Path 37009",
    d: "M459.4,312.155h1.8v7.586h-1.77l-.092-1.108a2.882,2.882,0,0,1-2.463,1.339,4,4,0,0,1,.047-8,2.787,2.787,0,0,1,2.416,1.231Zm-4.555,3.785a2.173,2.173,0,0,0,2.247,2.308c2.955,0,2.955-4.6,0-4.6A2.16,2.16,0,0,0,454.849,315.94Z",
    transform: "translate(-9.674 -4.442)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37010",
    "data-name": "Path 37010",
    d: "M468.453,308.871a1.108,1.108,0,0,1-2.216,0A1.108,1.108,0,0,1,468.453,308.871Zm-2.046,2.108V318.6h1.877v-7.617Z",
    transform: "translate(-13.295 -3.297)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37011",
    "data-name": "Path 37011",
    d: "M473.117,312.149l.139.877a2.235,2.235,0,0,1,2.138-1.077,2.88,2.88,0,0,1,1.955.723L476.5,314.3a1.88,1.88,0,0,0-1.355-.493,1.75,1.75,0,0,0-1.892,1.924v4h-1.877v-7.586Z",
    transform: "translate(-14.698 -4.436)",
    fill: "#09f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouair);
export default __webpack_public_path__ + "static/media/youair.de3c39ce8e20f5cbd5081d794ba6e67b.svg";
export { ForwardRef as ReactComponent };